<script setup>
// One numbered step of the outbound wizard.
//
// Whether a step exists yet is the parent's call — it owns the answers that unlock it —
// so this renders unconditionally and the wizard mounts each section only once its
// predecessor is answered. A step that has not appeared cannot be tabbed into either,
// which dimming with `pointer-events-none` never prevented.
defineProps({
  step: { type: Number, required: true },
  title: { type: String, required: true },
  description: { type: String, default: '' },
  done: { type: Boolean, default: false },
});
</script>

<template>
  <section class="w-full p-5 border rounded-xl border-n-weak bg-n-alpha-2">
    <header class="flex items-start gap-3">
      <span
        class="flex items-center justify-center size-7 shrink-0 rounded-full text-xs font-semibold"
        :class="
          done
            ? 'bg-n-brand text-white'
            : 'bg-n-alpha-1 text-n-slate-11 border border-n-weak'
        "
      >
        <i v-if="done" class="i-lucide-check size-4" />
        <template v-else>{{ step }}</template>
      </span>
      <div class="flex-1 min-w-0">
        <h2 class="text-sm font-medium text-n-slate-12">{{ title }}</h2>
        <p v-if="description" class="mt-0.5 text-xs text-n-slate-10">
          {{ description }}
        </p>
      </div>
      <slot name="aside" />
    </header>

    <div class="mt-4">
      <slot />
    </div>
  </section>
</template>
